import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CpeInfoViewComponent } from './cpe-info-view.component';

@NgModule({
	imports: [
		ContainerComponentModule,
		TextComponentModule,
	],
	declarations: [
		CpeInfoViewComponent
	],
	exports: [
		CpeInfoViewComponent
	]
})
export class CpeInfoViewComponentModule {

}
